export const PROFILE_ENDPOINTS = {
  GET_PROFILE: "/v1/admin/profile",
  UPDATE_PROFILE: "/v1/admin/update",
  UPLOAD_FILE: "/v1/utility/upload-file",
  ADMIN_ACTIVITY: "/v1/activity/admin",
  ADMIN_PREFERENCE: '/v1/admin/preference',
  ADMIN_CHANGE_PASSWORD: '/v1/admin/change-password',
  GET_ADMIN_SESSION: '/v1/sessions/admin/active',
  LOGOUT_ADMIN_SESSION: '/v1/sessions/admin/logout',
  LOGOUT_ALL_ADMIN_SESSION: '/v1/sessions/admin/invalidate/all',
  ADMIN_SETUP_2FA: '/v1/admin/setup-2fa',
  ADMIN_REGENERATE_BACKUP_CODES: '/v1/admin/mfa-backup-regenerate',
  ADMIN_MFA_RESET: '/v1/admin/mfa-reset',
  EXPORT_ACTIVITY: '/v1/activity/admin/export/all'
}